var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333840",
    d: "M23.014 11.772c-.032-.073-.812-1.803-2.554-3.545-1.616-1.614-4.393-3.54-8.46-3.54s-6.844 1.926-8.46 3.54C1.798 9.97 1.018 11.698.986 11.772a.56.56 0 0 0 0 .458c.032.072.812 1.802 2.554 3.543 1.616 1.615 4.393 3.54 8.46 3.54s6.844-1.925 8.46-3.54c1.742-1.741 2.522-3.468 2.554-3.543a.56.56 0 0 0 0-.458M12 18.188c-2.942 0-5.51-1.071-7.636-3.181A12.6 12.6 0 0 1 2.127 12a12.6 12.6 0 0 1 2.237-3.006C6.489 6.884 9.058 5.813 12 5.813s5.51 1.07 7.636 3.181A12.6 12.6 0 0 1 21.873 12c-.598 1.145-3.592 6.188-9.873 6.188m0-10.5a4.312 4.312 0 1 0 0 8.624 4.312 4.312 0 0 0 0-8.625m0 7.5a3.187 3.187 0 1 1 0-6.375 3.187 3.187 0 0 1 0 6.374"
  })));
};
export default SvgEye;